"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalLossReviewStrategy = void 0;
var TotalLossReviewStrategy;
(function (TotalLossReviewStrategy) {
    TotalLossReviewStrategy["TotalLoss"] = "TOTAL_LOSS";
    TotalLossReviewStrategy["Repairable"] = "REPAIRABLE";
})(TotalLossReviewStrategy = exports.TotalLossReviewStrategy || (exports.TotalLossReviewStrategy = {}));
